import React from "react";

import { useTranslation } from "react-i18next";

import ViewDialog from "@components/Dialog";
import InformationView from "@components/InformationView";
import { parseValue } from "@lib/utils/string";
import { User } from "@lib/types/users";

interface Props {
  viewUserDialogOpen: boolean;
  setViewUserDialogOpen: (open: boolean) => void;
  userData?: User;
}

const ViewUser: React.FC<Props> = ({
  viewUserDialogOpen,
  setViewUserDialogOpen,
  userData,
}) => {
  const { t } = useTranslation();

  const userInfo = [
    {
      label: t("admin.users.firstName"),
      value: parseValue(userData?.first_name),
      columnSize: 2,
    },
    {
      label: t("admin.users.lastName"),
      value: parseValue(userData?.last_name),
      columnSize: 2,
    },
    {
      label: t("admin.users.email"),
      value: parseValue(userData?.email),
      columnSize: 2,
    },
    {
      label: t("admin.users.organization"),
      value: parseValue(userData?.organization),
      columnSize: 2,
    },
    {
      label: t("admin.users.sendCommandType"),
      value: t(`admin.commandType.${userData?.send_command_type}`),
      columnSize: 2,
    },
    {
      label: t("admin.users.status"),
      value: t(`admin.userStatus.${userData?.status}`),
      columnSize: 2,
    },
  ];

  return (
    <ViewDialog
      title={t("admin.users.view")}
      isOpen={viewUserDialogOpen}
      handleClose={() => {
        setViewUserDialogOpen(false);
      }}
    >
      <InformationView
        title={t("admin.users.userInformation")}
        data={userInfo}
        columns={4}
      />
    </ViewDialog>
  );
};

export default ViewUser;
